// @mui
import { Box, Typography, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Person } from '@mui/icons-material';
// hooks
import useAuth from '../../../hooks/useAuth';
// components
import MyAvatar from '../../../components/MyAvatar';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        p: 0.75,
        pl: 1,
        pr: 1.5,
        borderRadius: '24px',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        color: 'text.primary',
        boxShadow: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {user?.profile_image ? (
          <MyAvatar sx={{ width: 32, height: 32 }} />
        ) : (
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              bgcolor: (theme) => alpha(theme.palette.success.main, 0.16),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'success.main',
            }}
          >
            <Person sx={{ width: 18, height: 18 }} />
          </Box>
        )}
      </Box>

      <Stack spacing={0} sx={{ textAlign: 'left', minWidth: 60 }}>
        <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary', lineHeight: 1.2 }}>
          {user?.username || 'User'}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, fontSize: '0.65rem', textTransform: 'uppercase', lineHeight: 1 }}>
          {user?.type || 'SMART'}
        </Typography>
      </Stack>
    </Box>
  );
}
